<!-- 国家选择弹框 -->
<template>
  <div>
    <van-popup v-model="isShow" round position="bottom">
      <van-picker
        closeable
        :default-index="defaultDountryIndex"
        :columns="countryList"
        @cancel="handleCancel"
        key="applyUserItem"
      >
        <template #option="item">
          <div @click="handleConfirm(item)">
            {{ item.name }}
          </div>
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>


<script>
import { getDictByType } from "@/api/common.js";

export default {
  name: "countryPicker",
  components: {},
  data() {
    //这里存放数据
    return {
      defaultDountryIndex:-1,
      countryList: [],
      isShow: false,
      UserItem:null
    };
  },
  //方法集合
  methods: {
    handlePop() {
      this.isShow = true;
    //   this.UserItem = UserItem
    },
    handleCancel() {
      this.isShow = false;
    },
    fillCountryListData() {
      getDictByType({
        //数据类型(country：国籍；nation：民族；identification_type：证件类型：qualifications：学历；degree：学位；politics：政治面貌)
        type: "country",
      }).then((res) => {
        const list = res.data;
        this.countryList.push(...list);
        this.setDefaultCountry();
      });
    },
    setDefaultCountry() {
      this.defaultDountryIndex = this.countryList.findIndex(
        (ele) => ele.name === "中国"
      );
    },
    handleConfirm(value) {
    //   this.UserItem.countryName = value.name;
      this.$emit('setCountryPicker',value)
      this.handleCancel();
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.fillCountryListData();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
</style>